<template>
    <transition :duration="{ enter: 0, leave: 300 }">
        <div v-show="show">
            <div class="flex h-screen p-8">
                <fade-transition>
                    <div
                        v-show="show"
                        class="fixed inset-0 transition-opacity"
                    >
                        <div
                            @click="close"
                            class="absolute inset-0 opacity-75 overlay-bg"
                        ></div>
                    </div>
                </fade-transition>

                <modal-transition>
                    <div
                        v-show="show"
                        class="p-3 overflow-hidden transition-all transform rounded-lg shadow-xl tier-3-bg sm:w-full"
                        role="dialog"
                        aria-modal="true"
                    >
                        <div class="flex flex-col items-center justify-center w-full space-y-3">
                            <h2 class="text-lg font-medium leading-6 tier-3-text-emphasize">Global Search</h2>
                            <ui-input
                                class="max-w-md"
                                type="text"
                            />
                        </div>
                    </div>
                </modal-transition>
            </div>
        </div>
    </transition>
</template>
<script>
import FadeTransition from '@/components/Transitions/Fade.vue';
import ModalTransition from '@/components/Transitions/Modal.vue';
import PrimaryButton from '@/components/ui/UiPrimaryButton.vue';
import SecondaryButton from '@/components/ui/UiSecondaryButton.vue';
import UiInput from '@/components/ui/UiInput.vue';

export default {
    name: 'navigation-confirmation-modal',
    components: {
        FadeTransition,
        ModalTransition,
        PrimaryButton,
        SecondaryButton,
        UiInput,
    },

    props: {
        show: {
            default: false,
        },
    },

    methods: {
        close() {
            this.$store.dispatch('app/hideGlobalSearch');
        },
    },
};
</script>
